export default {"src":"/_next/static/media/instagram-icon.c01b679c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};